import type { ReactNode } from "react"
import type { FallbackProps } from "react-error-boundary"
import { ErrorBoundary } from "react-error-boundary"

import Button from "~/v2/components/ui/button"

const ErrorFallback = ({ resetErrorBoundary }: FallbackProps) => {
  return (
    <div className="flex h-full w-full flex-col items-start justify-center gap-4 p-6">
      <h2 className="text-lg font-semibold text-foreground">
        Something went wrong
      </h2>
      <Button onClick={resetErrorBoundary}>Try again</Button>
    </div>
  )
}

const Page = ({ children }: { children: ReactNode }) => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>{children}</ErrorBoundary>
  )
}

export default Page
